import type { NextPage } from 'next'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'
import CustomImage from '../components/customImage/CustomImage'
import styles from '../styles/pages/StaticPage.module.scss'

import CustomMetaData from '../components/general/customMetaData/CustomMetaData'
import { GenericPageLayoutProps } from '../components/general/genericPageLayout/GenericPageLayout'

import { useGlobalContentContext } from '../context/GlobalContentContext'

import { parseGenericPage } from '../utils/parsers'
import { getAPI, createMarkup } from '../utils/helpers'

type Props = {} & GenericPageLayoutProps

const StaticPage = (props: Props) => {
  const { setData } = useGlobalContentContext()

  useEffect(() => {
    setData(props.globalData)
  }, [props.globalData, setData])

  return (
    <div className={styles.container}>
      <CustomMetaData
        title={props.originalResponse.meta_title}
        description={props.originalResponse.meta_description}
        image={props.originalResponse.meta_image}
      />

      <div className={styles.main}>
        <section className={styles.hero}>
          <div className={styles.heroContentContainer}>
            <h1 className={styles.heroTitle}>{props.originalResponse.title}</h1>
          </div>
          {props.originalResponse.staticpageimage && (
            <div className={styles.heroImage}>
              <CustomImage
                src={props.originalResponse.staticpageimage}
                layout="fill"
                objectFit="cover"
              />
            </div>
          )}
        </section>

        <section className={styles.content}>
          <h2 className={styles.contentSubTitle}>
            {props.originalResponse.sub_title}
          </h2>
          <div
            className={styles.contentContainer}
            dangerouslySetInnerHTML={createMarkup(
              props.originalResponse.detail
            )}
          ></div>
        </section>
      </div>
    </div>
  )
}

type ParamsType = {
  params: {
    slug: string
  }
}

export async function getStaticProps({ params }: ParamsType) {
  const page: GenericPageLayoutProps = await parseGenericPage(
    `${getAPI()}/static-pages/${params.slug}/`
  )

  return {
    props: {
      originalResponse: page.originalResponse,
      globalData: page.globalData,
      title: page.title,
    },
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS,
  }
}

export async function getStaticPaths() {
  const res = await fetch(`${getAPI()}/static-pages/`)
  const pages = await res.json()

  const paths = pages.map((page: any) => ({
    params: { slug: page.slug },
  }))

  return {
    paths,
    fallback: false,
  }
}

export const NEXTJS_REVALIDATE_PAGE_IN_SECONDS = 10
export default StaticPage
